// Main Layout Component - Wraps all authenticated pages
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';

const DRAWER_WIDTH = 260;

const Layout = () => {
    return (
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            <Sidebar />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    bgcolor: '#F8F9FA',
                    p: 3,
                    ml: `${DRAWER_WIDTH}px`,
                    minHeight: '100vh',
                    minWidth: 0,
                    width: `calc(100% - ${DRAWER_WIDTH}px)`,
                    overflowX: 'auto'
                }}
            >
                <Outlet />
            </Box>
        </Box>
    );
};

export default Layout;
